// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-88788404] .btn.dot-button {\n  color: #b9b9b9;\n  background: transparent;\n  border: none;\n  padding: 5px;\n}\n[data-v-88788404] .btn.dot-button:hover {\n    color: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
